import React, { useState } from 'react';
import './Calculator.css';

const Calculator = ({ onClose }) => {
  const [display, setDisplay] = useState('0');
  const [equation, setEquation] = useState('');
  const [isNewNumber, setIsNewNumber] = useState(true);

  const handleNumber = (num) => {
    if (display === '0' || isNewNumber) {
      setDisplay(num);
      setIsNewNumber(false);
    } else {
      setDisplay(display + num);
    }
  };

  const handleOperator = (op) => {
    setEquation(display + ' ' + op + ' ');
    setIsNewNumber(true);
  };

  const handleEqual = () => {
    const fullEquation = equation + display;
    try {
      // eslint-disable-next-line no-eval
      const result = eval(fullEquation);
      setDisplay(String(result));
      setEquation('');
      setIsNewNumber(true);
    } catch (error) {
      setDisplay('Error');
      setEquation('');
      setIsNewNumber(true);
    }
  };

  const handleClear = () => {
    setDisplay('0');
    setEquation('');
    setIsNewNumber(true);
  };

  const buttons = [
    { label: 'C', onClick: handleClear, className: 'calc-btn clear' },
    { label: '/', onClick: () => handleOperator('/'), className: 'calc-btn operator' },
    { label: '*', onClick: () => handleOperator('*'), className: 'calc-btn operator' },
    { label: '-', onClick: () => handleOperator('-'), className: 'calc-btn operator' },
    { label: '7', onClick: () => handleNumber('7'), className: 'calc-btn' },
    { label: '8', onClick: () => handleNumber('8'), className: 'calc-btn' },
    { label: '9', onClick: () => handleNumber('9'), className: 'calc-btn' },
    { label: '+', onClick: () => handleOperator('+'), className: 'calc-btn operator' },
    { label: '4', onClick: () => handleNumber('4'), className: 'calc-btn' },
    { label: '5', onClick: () => handleNumber('5'), className: 'calc-btn' },
    { label: '6', onClick: () => handleNumber('6'), className: 'calc-btn' },
    { label: '=', onClick: handleEqual, className: 'calc-btn equal' },
    { label: '1', onClick: () => handleNumber('1'), className: 'calc-btn' },
    { label: '2', onClick: () => handleNumber('2'), className: 'calc-btn' },
    { label: '3', onClick: () => handleNumber('3'), className: 'calc-btn' },
    { label: '0', onClick: () => handleNumber('0'), className: 'calc-btn zero' },
    { label: '.', onClick: () => handleNumber('.'), className: 'calc-btn' },
  ];

  return (
    <div className="calculator-popup">
      <div className="calculator-header">
        <span>Calculator</span>
        <button className="close-btn" onClick={onClose}>×</button>
      </div>
      <div className="calculator-display">
        <div className="calculator-equation">{equation}</div>
        <div className="calculator-current">{display}</div>
      </div>
      <div className="calculator-keypad">
        {buttons.map((btn, index) => (
          <button
            key={index}
            className={btn.className}
            onClick={btn.onClick}
            style={btn.label === '=' ? { gridRow: 'span 2' } : {}}
          >
            {btn.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Calculator;
